module.exports = __webpack_public_path__ + "img/jpg.e0b84a2.svg";